export class ConditionPriorToTypeDefinitionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getConditionPriorToTypeDefinitions() {
    return this.#http.get('/conditionPriorToTypeDefinition');
  }

  async createConditionPriorToTypeDefinition(body) {
    return this.#http.post('/conditionPriorToTypeDefinition', body);
  }

  async updateConditionPriorToTypeDefinition({ priorToTypeId, ...body }) {
    return this.#http.put(`/conditionPriorToTypeDefinition/${priorToTypeId}`, body);
  }

  async deleteConditionPriorToTypeDefinition({ priorToTypeId, reassignToId }) {
    return this.#http.delete(`/conditionPriorToTypeDefinition/${priorToTypeId}`, {
      params: reassignToId ? { reassignToId } : {},
    });
  }
}
